import 'modern-normalize'
import './assets/theme/variables.css'
import './assets/scss/base.scss'
import 'primeicons/primeicons.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import customPreset from '@/assets/theme/preset'
import i18n from '@/i18n'
import { configure } from 'vee-validate'
import App from './App.vue'
import router from './router'
import { pl } from '@/i18n/locales/UILocales/pl.ts'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import errorHandlerPlugin from '@/plugins/errorHandler.ts'
import services from '@/plugins/services.ts'
import axiosInstance from '@/api/axios.ts'
import setupAxiosInterceptors from '@/api/setupAxiosInterceptors.ts'
import { setupDynamicImportReloadHandler } from '@/helpers/chunkLoadError.ts'

configure({
    validateOnBlur: true,
    validateOnInput: false,
    validateOnChange: false,
    validateOnModelUpdate: false,
})

setupDynamicImportReloadHandler()

const app = createApp(App)

app.use(ToastService)

app.use(errorHandlerPlugin)

app.use(i18n)

const pinia = createPinia()
app.use(pinia)

setupAxiosInterceptors(axiosInstance, pinia)

app.use(services, { axios: axiosInstance })

app.directive('tooltip', Tooltip)

app.use(PrimeVue, {
    ripple: true,
    ...(i18n.global.locale.value === 'pl'
        ? {
              locale: {
                  ...pl,
              },
          }
        : {}),
    theme: {
        preset: customPreset,
        options: {
            darkModeSelector: '.lets-dark',
        },
    },
})

app.use(router)
app.mount('#app')
